// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"search-results-component_uk-open__v7p5o","grecaptcha-badge":"search-results-component_grecaptcha-badge__qtInJ","module":"search-results-component_module__VLMD2","searchBar":"search-results-component_searchBar__Eti41","anchors":"search-results-component_anchors__tN6nj","text":"search-results-component_text__f5Hb3","anchorTags":"search-results-component_anchorTags__j8ILv","results":"search-results-component_results__uVTon"};
    if(module.hot) {
      // 1750413083252
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  